import type { ActionOperation } from "components/editorComponents/GlobalSearch/utils";

export const useModuleOptions = (): ActionOperation[] => {
  return [];
};
